import { LoadSet } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function get(guid: string): Promise<LoadSet> {
  return DesignService.get(`loadSets/${guid}`);
}
